import * as React from 'react';
import { forwardRef, useMemo } from 'react';
import type { TextFieldProps } from '@components/moleculs/text-field/types';
import type { InputProps as InputPropsBase } from '@mui/material/Input/Input';
import type { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';
import cs from 'classnames';
import { styled } from 'styled-components';

import { Input } from './styles';

const Molecule = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
    const {
        className,
        InputProps,
        InputLabelProps,
        required,
        fieldState,
        hint,
        helperText,
        disabled,
        tooltipProps,
        inputSize = 'm',
        helperTextStatic = false,
        ...rest
    } = props;
    const errorText = useMemo(() => {
        if (fieldState?.error?.message) {
            return fieldState.error.message;
        }
        if (helperText && rest.error) {
            return helperText;
        }

        return '';
    }, [fieldState, rest.error, helperText]);

    return (
        <Input
            disabled={disabled}
            $inputSize={inputSize}
            $isMultiline={rest.multiline as boolean}
            $helperTextStatic={helperTextStatic}
            ref={ref}
            {...rest}
            InputProps={{
                // @ts-expect-error valid
                ...(rest?.variant === 'outlined'
                    ? ({} as OutlinedInputProps)
                    : ({ disableUnderline: true } as InputPropsBase)),
                ...InputProps,
            }}
            className={cs(className, {
                'Mui-error-container': !!errorText || props?.error,
            })}
            error={!!errorText}
            helperText={
                (!!hint || !!helperText) && (
                    <span className='helper-container'>
                        {!!hint && <span className='hint'>{hint}</span>}
                        {helperText}
                    </span>
                )
            }
        />
    );
});

export const TextField = styled(Molecule)({});
